// What the status alone does not say, beside it in the basic details (TX-US-0036, TX-US-0042):
// why a counterparty was rejected or returned, that an override is asked for and why, and whether
// an approval was given with conditions or by exception - with Legal's reason and a link to the
// written reply it cites.

import { getCounterpartyDocumentDownload } from '../../api.js';
import { notify } from '../../ui/notify.jsx';

const when = (iso) => new Date(iso).toLocaleString();

function EvidenceLink({ counterpartyId, documentId }) {
  const open = async () => {
    try {
      const { download_url: url } = await getCounterpartyDocumentDownload(counterpartyId, documentId);
      window.open(url, '_blank', 'noopener');
    } catch (err) {
      notify(err.message);
    }
  };
  return <button type="button" className="link-button" onClick={open}>the written reply</button>;
}

export default function StatusNotes({ record }) {
  const override = record.override;
  return (
    <>
      {record.status === 'REJECTED' && (
        <>
          <dt>Rejected</dt>
          <dd>
            {record.rejection_reason}
            <small className="muted"> — {record.updated_by}, {when(record.updated_at)}</small>
          </dd>
        </>
      )}
      {record.return_reason && (
        <>
          <dt>Returned</dt>
          <dd>
            {record.return_reason}
            <small className="muted"> — {record.updated_by}, {when(record.updated_at)}</small>
          </dd>
        </>
      )}
      {override && record.status === 'OVERRIDE_REQUESTED' && (
        <>
          <dt>Rejected by Legal</dt>
          <dd>
            {override.reason}
            <small className="muted"> — {override.requested_by}, {when(override.requested_at)};
              referred to {override.approvers_emailed.join(', ')}, who may override it</small>
          </dd>
        </>
      )}
      {override?.outcome === 'GRANTED' && record.status === 'APPROVED' && (
        <>
          <dt>Approved by exception</dt>
          <dd>
            Legal rejected it: {override.reason}. {override.approver} overrode the rejection,
            in <EvidenceLink counterpartyId={record.counterparty_id}
                             documentId={override.evidence_document_id} />.
          </dd>
        </>
      )}
      {record.approval_conditions && record.status === 'APPROVED' && (
        <>
          <dt>Approved with conditions</dt>
          <dd>{record.approval_conditions}</dd>
        </>
      )}
    </>
  );
}
